export default __webpack_public_path__ + "static/media/cloud-computing.9746c800.svg";